import React from 'react';
import { noop } from 'lodash';

const AppContext = React.createContext({
  language: 'en',
  setLanguage: noop,
  site: null,
  setSite: noop,
  currentUser: null,
  navigate: noop,
  request: noop,
  useActionControl: noop,
  dialog: null,
  paletteType: 'light',
  setPaletteType: noop,
  globalTemplates: [],
  userService: null,
});

export default AppContext;
